import { ICON_CALENDAR } from "common/constants";
import React from "react";
import { Link } from "react-router-dom";
import * as moment from "moment";

const SanctionItem = ({
  data,
  index,
  entityType,
}: {
  data: any;
  index: number;
  entityType: any;
}) => {
  let details = [];
  let link = "#";
  if (entityType === "eu-sanctions-list") {
    link = `/sanctions-list/eu/${data?.id}`;
    data?.firstName &&
      details.push(
        `<span class="fw-medium">First Name:</span> ${data.firstName}`
      );
    data?.middleName &&
      details.push(
        `<span class="fw-medium">Middle Name:</span> ${data.middleName}`
      );
    data?.lastName &&
      details.push(
        `<span class="fw-medium">Last Name:</span> ${data.lastName}`
      );
    data?.programme &&
      details.push(
        `<span class="fw-medium">Programme:</span> ${data.programme}`
      );
    data?.reference &&
      details.push(
        `<span class="fw-medium">Reference:</span> ${data.reference}`
      );
    data?.aliasNames &&
      details.push(
        `<span class="fw-medium">Alias Names:</span> ${data.aliasNames}`
      );
    data?.gender && details.push(`Gender: ${data?.gender}`);
  } else if (entityType === "us-sanctions-list") {
    link = `/sanctions-list/us/${data?.id}`;
    data?.firstName &&
      details.push(
        `<span class="fw-medium">First Name:</span> ${data.firstName}`
      );
    data?.lastName &&
      details.push(
        `<span class="fw-medium">Last Name:</span> ${data.lastName}`
      );
    data?.aliasNames &&
      details.push(
        `<span class="fw-medium">Alias Names:</span> ${data.aliasNames}`
      );
    data?.program &&
      details.push(`<span class="fw-medium">Program:</span> ${data.program}`);
    data?.nationality &&
      details.push(
        `<span class="fw-medium">Nationality:</span> ${data?.nationality}`
      );
    data?.reference &&
      details.push(
        `<span class="fw-medium">Reference:</span> ${data.reference}`
      );
    data?.designateType &&
      details.push(`Designate Type: ${data.designateType}`);
    data?.citizenship && details.push(`Citizenship: ${data.citizenship}`);
  } else if (entityType === "uk-sanctions-list") {
    link = `/sanctions-list/uk/${data?.id}`;
    data?.fullName &&
      details.push(
        `<span class="fw-medium">Full Name:</span> ${data.fullName}`
      );
    data?.aliasNames &&
      details.push(
        `<span class="fw-medium">Alias Names:</span> ${data.aliasNames}`
      );
    data?.uniqueID &&
      details.push(
        `<span class="fw-medium">Unique ID:</span> ${data.uniqueID}`
      );
    data?.unReferenceNumber &&
      details.push(
        `<span class="fw-medium">UN Reference Number:</span> ${data.unReferenceNumber}`
      );
    data?.regime &&
      details.push(`<span class="fw-medium">Regime:</span> ${data.regime}`);
    data?.country && details.push(`Country: ${data.country}`);
    data?.gender && details.push(`Gender: ${data?.gender}`);
    data?.nationality && details.push(`Nationality: ${data.nationality}`);
  } else if (entityType === "un-designated-list") {
    link = `/sanctions-list/un-designated/${data?.id}`;
    data?.title &&
      details.push(`<span class="fw-medium">Full Name:</span> ${data.title}`);
    data?.reference &&
      details.push(
        `<span class="fw-medium">Reference:</span> ${data.reference}`
      );
    data?.aliasNames &&
      details.push(
        `<span class="fw-medium">Alias Names:</span> ${data.aliasNames}`
      );
    data?.citizenship &&
      details.push(
        `<span class="fw-medium">Citizenship:</span> ${data.citizenship}`
      );
    data?.designation &&
      details.push(
        `<span class="fw-medium">Designation:</span> ${data.designation}`
      );
    data?.dateOfBirth &&
      details.push(
        `<span class="fw-medium">Date of Birth:</span> ${data.dateOfBirth}`
      );
    data?.placeOfBirth &&
      details.push(
        `<span class="fw-medium">Place of Birth:</span> ${data.placeOfBirth}`
      );
    data?.address &&
      details.push(`<span class="fw-medium">Address:</span> ${data.address}`);
  } else if (entityType === "world-bank-banned-list") {
    link = `/sanctions-list/world-bank/${data?.id}`;
    data?.companyName &&
      details.push(
        `<span class="fw-medium">Company Name:</span> ${data.companyName}`
      );
    data?.country &&
      details.push(`<span class="fw-medium">Country:</span> ${data.country}`);
    data?.contactName &&
      details.push(
        `<span class="fw-medium">Contact Name:</span> ${data.contactName}`
      );
    data?.contactEmail &&
      details.push(
        `<span class="fw-medium">Contact Email:</span> ${data.contactEmail}`
      );
    data?.sanctionStartDate &&
      details.push(
        `<span class="fw-medium">Sanction Start Date:</span> ${data.sanctionStartDate}`
      );
    data?.sanctionEndDate &&
      details.push(
        `<span class="fw-medium">Sanction End Date:</span> ${data.sanctionEndDate}`
      );
  } else if (entityType === "ungm-list") {
    link = `/sanctions-list/ungm/${data?.id}`;
    data?.companyName &&
      details.push(
        `<span class="fw-medium">Company Name:</span> ${data.companyName}`
      );
    data?.country &&
      details.push(`<span class="fw-medium">Country:</span> ${data.country}`);
    data?.contactName &&
      details.push(
        `<span class="fw-medium">Contact Name:</span> ${data.contactName}`
      );
    data?.contactEmail &&
      details.push(
        `<span class="fw-medium">Contact Email:</span> ${data.contactEmail}`
      );
    data?.sanctionStartDate &&
      details.push(
        `<span class="fw-medium">Sanction Start Date:</span> ${data.sanctionStartDate}`
      );
    data?.sanctionEndDate &&
      details.push(
        `<span class="fw-medium">Sanction End Date:</span> ${data.sanctionEndDate}`
      );
  }

  const detailsString = details.join(", ");
  // Create a unique ID for this component instance to scope the styles
  const componentId = React.useMemo(
    () =>
      `sanction-item-${data?.id || Math.random().toString(36).substring(2, 9)}`,
    [data?.id]
  );

  return (
    <div className={index === 0 ? "pb-3" : "py-3"} id={componentId}>
      {/* Add scoped styles for highlighting em tags */}
      <style>
        {`
          #${componentId} em {
            background-color: #fff59d;
            font-style: normal;
            padding: 0 0px;
            border-radius: 2px;
            font-weight: 500;
          }
        `}
      </style>
      <h5 className="mb-1">
        <Link to={link}>
          <span
            dangerouslySetInnerHTML={{
              __html: data?.title || data?.companyName,
            }}
          ></span>
        </Link>
      </h5>
      <p className="text-success mb-2">
        <span className="me-2">
          {entityType === "eu-sanctions-list" && "EU Sanctions List"}
          {entityType === "us-sanctions-list" && "US Sanctions List"}
          {entityType === "uk-sanctions-list" && "UK Sanctions List"}
          {entityType === "un-designated-list" && "UN Designated List"}
          {entityType === "ungm-list" && "UNGM List"}
          {entityType === "world-bank-banned-list" && "World Bank Banned List"}
        </span>
        {/* <span className="badge bg-warning-subtle text-warning fs-11 me-2">
          SEMG Mention
        </span> */}
        {entityType === "eu-sanctions-list" && (
          <span className="badge bg-danger-subtle text-danger fs-11 me-2">
            EU Sanction
          </span>
        )}
        {entityType === "us-sanctions-list" && (
          <span className="badge bg-danger-subtle text-danger fs-11 me-2">
            US Sanction
          </span>
        )}
        {entityType === "uk-sanctions-list" && (
          <span className="badge bg-danger-subtle text-danger fs-11 me-2">
            UK Sanction
          </span>
        )}
        {entityType === "un-designated-list" && (
          <span className="badge bg-danger-subtle text-danger fs-11 me-2">
            UN Designated
          </span>
        )}
        {entityType === "world-bank-banned-list" && (
          <span className="badge bg-danger-subtle text-danger fs-11 me-2">
            World Bank Banned List
          </span>
        )}
        {entityType === "ungm-list" && (
          <span className="badge bg-danger-subtle text-danger fs-11 me-2">
            UNGM Debarred List
          </span>
        )}
      </p>
      <p
        className="text-muted mb-2"
        dangerouslySetInnerHTML={{ __html: `... ${detailsString} ...` }}
      ></p>
      <ul className="list-inline d-flex align-items-center g-3 text-muted fs-14 mb-0">
        <li className="list-inline-item">
          <div className="d-flex align-items-center">
            <div className="flex-shrink-0">
              <i className={ICON_CALENDAR}></i>
            </div>
            <div className="flex-grow-1 fs-13 ms-1">
              <span className="fw-medium">
                {moment(new Date(data?.updatedAt)).format("DD MMM  Y")}
              </span>
            </div>
          </div>
        </li>
      </ul>
    </div>
  );
};

export default SanctionItem;
